<template>
  <section>
    <banner-list :query="query" />
  </section>
</template>

<script>
import BannerList from '@/components/catalogs/BannerList'

export default {
  name: 'CatalogBanners',
  components: {
    BannerList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
